import React from 'react';
import { Button, Dialog } from '@material-ui/core';
import { ClassNameMap } from '@material-ui/styles/withStyles/withStyles';

import { EeModalTitle } from './EeModalTitle';
import { EeModalActions } from './EeModalActions';
import { EeModalContent } from './EeModalContent';

export interface EeModalProps {
  open: boolean;
  title: string | any;
  classes?: Partial<ClassNameMap>;
  className?: string;
  width?: any;
  submitTitle?: string;
  cancelTitle?: string;
  scroll?: 'body' | 'paper';
  children: React.ReactNode;
  actions?: React.ReactNode;
  onEntered?: () => void;
  onClose: () => void;
  onSubmit?: () => void;
}

export const EeModal: React.FC<EeModalProps> = ({
  open,
  title,
  classes,
  className,
  width,
  scroll,
  children,
  onEntered,
  onClose,
  onSubmit,
  submitTitle,
  cancelTitle,
  actions,
}) => {
  return (
    <Dialog
      classes={classes}
      fullWidth
      scroll={scroll}
      maxWidth={width || 'sm'}
      open={open}
      onClose={onClose}
      onEntered={onEntered}
      className={className}
    >
      <EeModalTitle onClose={onClose}>{title}</EeModalTitle>
      <EeModalContent>
        <div>{children}</div>
      </EeModalContent>
      <EeModalActions>
        {actions || (
          <div className="d-flex align-items-center w-100">
            <Button
              onClick={onClose}
              variant="outlined"
              color="primary"
              className="ml-auto mr-3"
            >
              {cancelTitle || 'Cancel'}
            </Button>
            <Button onClick={onSubmit} variant="contained" color="primary">
              {submitTitle || 'Save'}
            </Button>
          </div>
        )}
      </EeModalActions>
    </Dialog>
  );
};
